import { KTIcon } from '@/_metronic/helpers'
import {useListView} from '../../../core/ListViewProvider'

const TopupHistoryModalHeader = () => {
  const {itemId, setItemId} = useListView()

  return (
    <div className='modal-header'>
      {/* begin::Modal title */}
      <h2 className='fw-bolder'>View Topup History Detail</h2>
      {/* end::Modal title */}

      {/* begin::Close */}
      <div
        className='btn btn-icon btn-sm btn-active-icon-primary'
        data-kt-users-modal-action='close'
        onClick={() => setItemId!(undefined!)}
        style={{cursor: 'pointer'}}
      >
        <KTIcon iconName='cross' className='fs-1' />
      </div>
      {/* end::Close */}
    </div>
  )
}

export {TopupHistoryModalHeader}
